<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import CampaignDrawer from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignDrawer.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import WhatsAppCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/WhatsAppCampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const drawerRef = ref(null);
const isDrawerOpen = ref(false);
const confirmDeleteCampaignDialogRef = ref(null);
const selectedCampaign = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const WhatsAppCampaigns = computed(
  () => getters['campaigns/getWhatsAppCampaigns'].value
);

const hasNoWhatsAppCampaigns = computed(
  () => WhatsAppCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const editingCampaign = ref(null);

// A gaveta pede confirmação antes de trocar de campanha com alterações sem salvar.
const handleCreate = () => {
  drawerRef.value.runGuarded(() => {
    editingCampaign.value = null;
    isDrawerOpen.value = true;
  });
};

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.WHATSAPP.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.WHATSAPP.NEW_CAMPAIGN')"
    @click="handleCreate"
  >
    <CampaignList
      v-if="isFetchingCampaigns || !hasNoWhatsAppCampaigns"
      :campaigns="WhatsAppCampaigns"
      :title="t('CAMPAIGN.WHATSAPP.HEADER_TITLE')"
      :is-loading="isFetchingCampaigns"
      @delete="handleDelete"
    />
    <WhatsAppCampaignEmptyState
      v-else
      :title="t('CAMPAIGN.WHATSAPP.EMPTY_STATE.TITLE')"
      :subtitle="t('CAMPAIGN.WHATSAPP.EMPTY_STATE.SUBTITLE')"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
    <template #drawer>
      <CampaignDrawer
        ref="drawerRef"
        v-model:open="isDrawerOpen"
        type="whatsapp"
        :campaign="editingCampaign"
      />
    </template>
  </CampaignLayout>
</template>
